import { FaWhatsapp } from "react-icons/fa";

export const navLinksdata = [
    {
      _id: 1001,
      title: "Home",
      link: "home",
    },
    {
      _id: 1002,
      title: "Features",
      link: "features",
    },
    {
      _id: 1003,
      title: "Projects",
      link: "projects",
    },
    {
      _id: 1004,
      title: "Resume",
      link: "resume",
    },
    
    {
      _id: 1005,
      title: "Contact",
      link: "contact",
    },

    // {
    //   _id: 1006,
    //   title: "Wtsp",
    //   link: "https://wa.me/919876543210?text=May%20I%20help%20you%3F", 
    // }
    
    
  ];